<template lang="pug">
  div(:style="getStyle" @mouseover="showEdit=true" @mouseout="showEdit=false")
    v-btn.ml-2(v-if="canDownload" text icon color="primary"  @click="onClick")
      v-icon(small) get_app
    v-btn(v-show="showEditButton()" @click="navigateTo()" text icon color="primary")
       v-icon(small) edit
</template>
<script>
import { getBlob, mediaUrl } from "@/modules/uploads/blobCache";

export default {
  components: {},
  props: {
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    },
    src: String,

    border: {
      type: String,
      default: "1px solid #E5E5E5"
    },
    route: {
      type: Object,
      default: null
    },

    radius: {
      type: Number,
      default: 6
    },

    canDownload:{
      type: Boolean,
      default: false,
    },

    useThumbnail:{
      type: Boolean,
      default: true,
    },

    position:{
      type:String,
      default: "center"
    }
  },
  data: () => ({
    showEdit: false,
    resultObject: null,
    // Guards against an out-of-order response painting a stale image when src
    // changes faster than the lookups resolve.
    loadToken: 0
  }),

  computed: {
    getStyle: function() {
      var styleObject = {
        border: this.border,
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "background-position": this.position,
        display: "flex",
        "justify-content": "end",
        "align-items": "end",
        "border-radius": `${this.radius}px`,
        width: this.width + "px",
        height: this.height + "px",
        "font-size": "10px"
      };
      // Blobs whose thumbnail was never generated fall back to the original
      // file rather than requesting /media/<account>/null and rendering blank.
      let path = mediaUrl(this.resultObject);
      if (path) {
        // set the background
        styleObject["background-image"] = 'url("' + path + '")';
        // styleObject["border-style"] = "solid";
        // styleObject["border-width"] = "1px";
      } else {
        // styleObject["border-style"] = "dashed";
        // styleObject["border-width"] = "2px";
      }

      return styleObject;
    }
  },

  watch: {
    src: function(newValue) {
      if (newValue) {
        this.loadImage();
      } else {
        this.resultObject = null;
      }
    }
  },

  methods: {
    loadImage: function() {
      const token = ++this.loadToken;
      getBlob(this.src)
        .then(record => {
          if (token !== this.loadToken) return; // superseded by a newer src
          this.resultObject = record;
        })
        .catch(error => {
          if (token !== this.loadToken) return;
          this.resultObject = null;
          // console.warn survives the production build; console.log does not.
          console.warn(`ImageThumbnail: could not load blob ${this.src}`, error);
        });
    },

    navigateTo: function() {
      if (this.route) {
        this.$router.push(this.route).catch(()=>{});
      }
    },

    showEditButton: function() {
      if (this.route && this.showEdit) {
        return true;
      } else {
        return false;
      }
    },

    onClick:function() {
      if (!this.resultObject) return;

      const href = mediaUrl(this.resultObject, {
        preferOriginal: !this.useThumbnail
      });
      if (!href) return;

      this.fileLink = document.createElement("a");
      this.fileLink.href = href;

      this.fileLink.setAttribute("download", this.resultObject.original_name);
      document.body.appendChild(this.fileLink);
      this.fileLink.click();
    },




  },

  mounted() {
    if (this.src) {
      this.loadImage();
    }
  }
};
</script>
<style scoped lang="stylus"></style>
